<template>
    <div>

        <div class="vx-row">
            
            <div class="vx-col sm:w-full md:w-6/12 lg:w-6/12 xl:w-4/12 w-full mb-base">
                <div class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden items-no-padding" style="background-color: white">
                    <VuePerfectScrollbar class="scroll-area pt-4" :settings="scrollSettings">
                        <OrganizeMenus @selected="(val) => selectedMenu = val"/>
                        
                    </VuePerfectScrollbar>
                </div>
            </div>
            
            <div class="vx-col sm:w-full md:w-6/12 lg:w-6/12 xl:w-4/12 w-full mb-base">
                <div class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden items-no-padding" style="background-color: white">
                    <VuePerfectScrollbar class="scroll-area pt-4" :settings="scrollSettings">
                        <OrganizeProductTypes
                            :selectedMenuId="selectedMenu" 
                            @selected="(val) => selectedProductType = val" />
                    </VuePerfectScrollbar>
                </div>
            </div>

            <div class="vx-col sm:w-full md:w-6/12 lg:w-6/12 xl:w-4/12 w-full mb-base">
                <div class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden items-no-padding" style="background-color: white">
                    <VuePerfectScrollbar class="scroll-area pt-4" :settings="scrollSettings">
                        <OrganizeProducts
                            :selectedProductType="selectedProductType"/>
                    </VuePerfectScrollbar>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import OrganizeMenus from '@/components/organizer/OrganizeMenus.vue'
    import OrganizeProductTypes from '@/components/organizer/OrganizeProductTypes.vue'
    import OrganizeProducts from '@/components/organizer/OrganizeProducts.vue'
    import _misc from '@/assets/utils/misc'

    const ref = firebase.firestore()
    var batch = ref.batch()

    export default {
        props : {
            id : {
                type : String,
                required : false,
            }
        },

        components : {
            VuePerfectScrollbar,
            OrganizeMenus,
            OrganizeProductTypes,
            OrganizeProducts
        },

        data () {
            return {
                productTypeData: [],
                selectedMenu : null,
                selectedProductType: null,

                oldProductTypeId : '',
                productId : '',
                product : {
                    dispatched : true,
                    options : {},
                    value : 0,
                    enabled : true,
                    productType : {

                    }
                },
                scrollSettings : {
                    maxScrollbarLength  : 200,
                    scrollXMarginOffset : 100,
                    wheelSpeed          : 0.4
                },
                companyId : this.$store.getters.getCompanyID,
            }
        },

        provide () {
            return {
                $validator : this.$validator
            }
        },

        mounted () {
            if(typeof(this.id) != 'undefined') {
                this.productId = this.id
                this.getProductData()
            } else 
                this.productId = _misc.generateId(21)
        },

        methods : {
            async getProductData () {
                try {
                    this.$vs.loading()
                    let product = await ref.collection(`/company/${this.companyId}/products/`).doc(this.productId).get()
                    let productData = product.data()

                    if(product.empty) 
                        return

                    this.productId = product.id
                    this.oldProductTypeId = productData.productType.id
                    this.$set(this.product, 'updatedAt', new Date()) 
                    this.product = productData
                } catch (err) {
                    this.$error({
                        zIndex: 999999,
                        title: 'Erro',
                        content : `Erro ao obter produto: ${err.message}`
                    })
                } finally {
                    this.$vs.loading.close()
                }
            },

            updateProductData (product) {
                if(product.options.hasOwnProperty('size'))
                    if(!Object.keys(product.options.size.items).length)
                        this.$delete(product.options, 'size')

                this.product = Object.assign(product, this.product)

                this.updateProductScroll()
            },

            updateProductScroll () {
                this.$refs.scroll.update()
            },

            async saveProduct () {
                try {
                    let validate = await this.validateFields()
                    if(validate) throw new Error(validate)

                    let productRef = ref.collection(`/company/${this.companyId}/products/`).doc(this.productId);
                    this.$vs.loading()
                    
                    if(!this.product.hasOwnProperty('cod')) {
                        let currentCod = await this.autoIncrementCod()
                        this.$set(this.product, 'cod', currentCod) 
                    }

                    if(typeof(this.id) == 'undefined') {
                        batch.set(productRef, this.product)
                    } else {
                        batch.update(productRef, this.product)
                        await this.removeFromProductType(this.productId)
                    }
                    await this.insertOrUpdateProductInOption(this.productId)
                    await this.insertOrUpdateProductType(this.productId)
                    await batch.commit()
                    batch = ref.batch()
                    
                    this.$success({
                        zIndex: 999999,
                        title: 'Sucesso',
                        content : `Produto salvo com sucesso!`
                    })
                    this.$router.push('/product/all')
                } catch (err){
                    this.$error({
                        zIndex: 999999,
                        title: 'Erro',
                        content : `Erro ao salvar produto: ${err.message}`
                    })
                } finally {
                    this.$vs.loading.close()
                }
            },

            autoIncrementCod () {
                return new Promise(async (resolve, reject) => {
                    try {
                        let increment = ref.collection(`/company/${this.companyId}/counters/`).doc('products');
                        let hasDoc = await increment.get()

                        if(!hasDoc.exists) {
                            await increment.set({ current : firebase.firestore.FieldValue.increment(1) })
                        } else {
                            await increment.update({ current : firebase.firestore.FieldValue.increment(1) })
                        }                        
                        
                        let current = await increment.get()
                        let result = current.data()
                        resolve(result.current)
                    } catch (err) {
                        reject(err)
                    }
                })
                
            },

            validateFields () {
                return new Promise(resolve => {
                    if(!this.product.description) resolve('O produto precisa ter um nome')

                    resolve('')
                })
            },

            insertOrUpdateProductInOption (productId) {
                return new Promise(async resolve => {
                    try {
                        let objProductOptionsId = []
                        if(this.product.hasOwnProperty('options'))
                            Object.entries(this.product.options).forEach(option => {
                                if(option[0] != "size") objProductOptionsId.push(option[0])
                            })

                        let colRef = ref.collection(`/company/${this.companyId}/productInOption/`).doc(productId)
                        batch.set(colRef, {options: objProductOptionsId})
                        
                        resolve(true)
                    } catch (err) {
                        this.$error({
                            title: 'Erro inesperado',
                            content : `Erro ao tentar inserir produto dentro de opções ${err.message}`
                            })
                        resolve(false);
                    }
                })
            },

            removeFromProductType(productId) {
                var companyID = this.$store.getters.getCompanyID;

                return new Promise(async (resolve) => {
                    try {
                        let companyProductTypes = await ref.collection('company').doc(companyID).collection('productType').doc(this.oldProductTypeId).get()
                        let productTypes = companyProductTypes.data()

                        if (productTypes.hasOwnProperty('products')) {
                            delete productTypes.products[productId];
                        }

                        let pTypeRef = ref.collection('company').doc(companyID).collection('productType').doc(this.oldProductTypeId);
                        batch.update(pTypeRef, productTypes)
                        resolve(true);
                    } catch (err) {
                        this.$error({
                            title: 'Erro inesperado',
                            content : `Erro ao tentar excluir o tipo de produto. ${err.message}`
                            })
                        resolve(false);
                    }
                })
            },

            async insertOrUpdateProductType (productId) {
                var companyID = this.$store.getters.getCompanyID;
                var selectedProductType = this.product.productType;

                return new Promise(async resolve => {
                    try {
                        let companyProductTypes = await ref.collection('company').doc(companyID).collection('productType').doc(selectedProductType.id).get()
                        let productTypes = companyProductTypes.data()
                        const hours = productTypes.products[productId] ? productTypes.products[productId].hours : {}

                        let productTypeObj = {
                            description: this.product.description || '',
                            details: this.product.details || '',
                            id: productId,
                            image: this.product.image || '',
                            priceDescription : '',
                            enabled : this.product.enabled,
                            hours : hours || {}
                        }

                        if(this.product.hasOwnProperty('order'))
                            productTypeObj.order = this.product.order

                        const priceDesc = this.getProductTypePriceDesc()
                        if(priceDesc)
                            productTypeObj.priceDescription = `R$ ${priceDesc.toFixed(2).replace('.',',')}`
                        productTypes.products[productId] = productTypeObj;

                        let pTypeRef = ref.collection('company').doc(companyID).collection('productType').doc(selectedProductType.id)
                        batch.update(pTypeRef, productTypes)

                        this.oldProductTypeId = selectedProductType.id;
                        resolve(true)
                    } catch (err) {
                        this.$error({
                            title: "Erro inesperado",
                            content: `Erro inesperado ao tentar salvar tipo de produto. ${err.message}}`
                        })

                        resolve(false)
                    }
                })
            },

            getProductTypePriceDesc () {
                let lowestPrice = 0;
                if(this.product.options.hasOwnProperty('size'))
                    lowestPrice += this.getLowestSizePrice()
                else
                    lowestPrice += this.product.value;

                return lowestPrice
            },

            getLowestSizePrice () {
                let sizes = this.product.options.size.items
                let lowestPrice = 0;
                for (let size in sizes) {
                    if(lowestPrice == 0) lowestPrice = sizes[size].value
                    lowestPrice = lowestPrice > sizes[size].value ? sizes[size].value : lowestPrice
                }
                return lowestPrice
            },
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/vuexy/apps/chat.scss";

    .scroll-area { 
        height: 75vh
    }

    .scroll-area-product { 
        height: 68.33vh
    }
</style> 